<div class="modal-header">
    <h3 style="font-weight: bold;">Panel de control de usuario</h3>
    <button type="button" class="close" aria-label="Close" (click)="_close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="row">
        <div class="col-md-12">
            <div>

                <ul ngbNav #nav="ngbNav" class="nav-tabs">
                    <li ngbNavItem>
                        <a ngbNavLink>Datos generales</a>
                        <ng-template ngbNavContent>

                            <div class="container-fluid">
                                <h4 class="card-title mt-2 mb-1"><b>Modificar Usuario</b></h4>

                                <div class="row">
                                    <div class="col-sm-12 col-lg-6">
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label">Código:</label>
                                            <div class="col-sm-7">
                                                <input style="text-align: center;"
                                                    class="form-control form-control-sm text-center col-sm-7"
                                                    [(ngModel)]="coduserViewUpdate" maxlength="10" name="coduserUpdate"
                                                    tabindex="1" type="text" disabled>
                                            </div>
                                            <app-custom-switch [(valor)]="activoViewUpdate" style="margin-left: 30px;"
                                                [identificador]="'1'"></app-custom-switch>
                                        </div>
                                    </div>
                                </div>


                                <div class="form-group row">
                                    <label class="col-sm-2 col-form-label">Nombre y
                                        apellido:</label>
                                    <div class="col-sm-5">
                                        <input class="form-control form-control-sm text-left"
                                            [(ngModel)]="nombresViewUpdate" maxlength="45" tabindex="3"
                                            name="nombresUpdate" type="text">
                                    </div>
                                </div>



                                <div class="form-group row">
                                    <label class="col-sm-2  col-form-label">Cargo:</label>
                                    <div class="col-sm-5">
                                        <input class="form-control form-control-sm" [(ngModel)]="cargoViewUpdate"
                                            maxlength="45" tabindex="4" name="cargoUpdate" type="text">
                                    </div>
                                </div>
                                <div class="form-group row">
                                    <label class="col-sm-2  col-form-label">Correo:</label>
                                    <div class="col-sm-5">
                                        <input class="form-control form-control-sm" [(ngModel)]="correoViewUpdate"
                                            autocomplete="off" maxlength="100" tabindex="4" name="cargoUpdate"
                                            type="email" [ngClass]="estiloValidacion(correoViewUpdate, 'correo')">
                                    </div>
                                </div>


                                <div class="row border-top pt-3">
                                    <div class="col-sm-12 col-lg-6">
                                        <div class="form-group row">
                                            <label class="col-sm-4 col-form-label">
                                                Clave actual:
                                            </label>
                                            <div class="col-sm-6">
                                                <input tabindex="5" autocomplete="new-password"
                                                    [disabled]="!modificarclaveViewUpdate"
                                                    class="form-control form-control-sm"
                                                    [(ngModel)]="claveactualViewUpdate" maxlength="20"
                                                    name="claveactualViewUpdate"
                                                    [type]="estadoVisivilidad[4].mostrar?'text':'password'">
                                            </div>
                                            <div class="col-sm-2 my-auto" *ngIf="modificarclaveViewUpdate">
                                                <span class="toggle-password font-16" style="cursor: pointer;">
                                                    <i class="fa"
                                                        [ngClass]="estadoVisivilidad[4].mostrar?'fa-eye-slash':'fa-eye'"
                                                        (click)="toggleMostrarContrasena(4)"
                                                        style="cursor: pointer;"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-lg-6">
                                        <div class="form-group row">
                                            <input tabindex="6" class="form-check-input" type="checkbox"
                                                id="modificarclaveViewUpdate" [(ngModel)]="modificarclaveViewUpdate"
                                                (change)="cambioEstadoModificarClave()" checked>
                                            <div class="col-sm-5 mt-1">
                                                <label class="form-check-label" for="inlineCheckbox1"><i
                                                        class="fa fa-lock"></i>
                                                    Modificar Clave:</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="row border-bottom mb-3">
                                    <div class="col-sm-12 col-lg-6">
                                        <div class="form-group row">
                                            <label class="col-sm-4  col-form-label">
                                                Nueva clave:
                                            </label>
                                            <div class="col-sm-6">
                                                <input tabindex="7" autocomplete="new-password"
                                                    [disabled]="!modificarclaveViewUpdate"
                                                    class="form-control form-control-sm" [(ngModel)]="claveViewUpdate"
                                                    maxlength="20" name="confirclaveUpdate"
                                                    [type]="estadoVisivilidad[2].mostrar?'text':'password'"
                                                    (input)="validarRequisitosContrasena(claveViewUpdate)"
                                                    [ngClass]="estiloValidacion(claveViewUpdate, 'contrasenia')">
                                            </div>
                                            <div class="col-sm-2 my-auto" *ngIf="modificarclaveViewUpdate">
                                                <span class="toggle-password font-16" style="cursor: pointer;">
                                                    <i class="fa"
                                                        [ngClass]="estadoVisivilidad[2].mostrar?'fa-eye-slash':'fa-eye'"
                                                        (click)="toggleMostrarContrasena(2)"
                                                        style="cursor: pointer;"></i>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <label class="col-sm-4  col-form-label">
                                                Confirmar nueva clave:
                                            </label>
                                            <div class="col-sm-6">
                                                <input tabindex="8" autocomplete="new-password"
                                                    [disabled]="!modificarclaveViewUpdate"
                                                    class="form-control form-control-sm"
                                                    [(ngModel)]="claveconfirViewUpdate" maxlength="20"
                                                    name="confirclaveUpdate"
                                                    [type]="estadoVisivilidad[3].mostrar?'text':'password'"
                                                    [ngClass]="estiloValidacion(claveconfirViewUpdate, 'confirmarContrasenia')">
                                            </div>
                                            <div class="col-sm-2 my-auto" *ngIf="modificarclaveViewUpdate">
                                                <span class="toggle-password font-16" style="cursor: pointer;">
                                                    <i class="fa"
                                                        [ngClass]="estadoVisivilidad[3].mostrar?'fa-eye-slash':'fa-eye'"
                                                        (click)="toggleMostrarContrasena(3)"
                                                        style="cursor: pointer;"></i>
                                                </span>
                                            </div>
                                        </div>

                                        <div class="form-group row">
                                            <label class="col-sm-4 text-left control-label col-form-label">
                                                Fecha de expiración
                                            </label>
                                            <div class="col-sm-6">
                                                <input tabindex="8" class="form-control" [(ngModel)]="fechaExpiracion"
                                                    name="fechaExpiracion" type="date" disabled>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-sm-12 col-lg-6" style="margin-top: -20px;">
                                        <ul class="pl-0">
                                            <li *ngIf="!requisitosContrasena.longitud">La contraseña debe tener al menos
                                                8 caracteres</li>
                                            <li *ngIf="!requisitosContrasena.minuscula">Debe contener al menos 1 letra
                                                minúscula</li>
                                            <li *ngIf="!requisitosContrasena.mayuscula">Debe contener al menos 1 letra
                                                mayúscula</li>
                                            <li *ngIf="!requisitosContrasena.numero">Debe contener al menos 1 número
                                            </li>
                                            <li *ngIf="!requisitosContrasena.especial">Debe contener al menos 1 caracter
                                                especial</li>
                                            <li *ngIf="!requisitosContrasena.igualdad">Las contraseñas deben coincidir
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-12 col-lg-12">
                                        <div class="form-group row mb-0">
                                            <label class="col-sm-2 col-form-label">Sucursal:</label>
                                            <div class="col-sm-1">
                                                <input style="text-align: center;" class="form-control form-control-sm"
                                                    [(ngModel)]="codsucViewUpdate" name="codsucUpdate" type="number"
                                                    disabled>
                                            </div>
                                            <div class="col-sm-3">
                                                <select class="custom-select select-estandar-fix"
                                                    [(ngModel)]="codsucViewUpdate" name="codsucUpdate" #selectMoneda
                                                    tabindex="10">
                                                    <option *ngFor="let lst of sucursales" [value]="lst.codsuc">
                                                        {{lst.sucursal}}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </ng-template>
                    </li>
                    <li ngbNavItem>
                        <a ngbNavLink>Firma</a>
                        <ng-template ngbNavContent>

                            <div [hidden]="false" class="ibox-head" style="margin-top:20px">

                                <div class="row">
                                    <div class="col-md-8">
                                        <div class="agrupador-firma" style="margin-bottom: 0;">
                                            <label class="col-form-label ml-3"
                                                style="margin-right: 10px;font-weight: bold;color: black;">
                                                Tipo de firma:
                                            </label>
                                            <div class="col-md-8 mt-2">
                                                <select class="tsiSelect form-select form-select-sm text-center"
                                                    style="font-weight: bold;color: black;"
                                                    (change)="onChangeFirma($event.target.value)" id="cboTipoFirma">
                                                    <option value="1">1 - Cotizaciones y Orden de Pedido</option>
                                                    <option value="2">2 - Certificados de Calidad</option>
                                                </select>
                                            </div>
                                        </div>
                                        <button class="btn btn-rounded btn-info m-b-15" (click)="guardarLogoCabecera()"
                                            style="margin-right: 50px; margin-top: 10px;"
                                            [hidden]="ocultarBotonGuardarCabecera"
                                            [disabled]="disabledbotonImagenCabecera" tabindex="14"><i
                                                class="fa fa-save"></i> &nbsp;Guardar Firma</button>
                                        <input #fileUploadCabecera [hidden]="ocultarBotonGuardarCabecera" type="file"
                                            id="file" accept=".jpg" (change)="uploadImagenCabecera($event)">
                                        <button type="button" class="btn btn-rounded btn-danger btn-sm m-b-15"
                                            style="width: 90px; height: 25px;" (click)="deleteLogoCabecera()"
                                            [hidden]="ocultarBotonEliminarCabecera"><i
                                                class="fas fa-trash-alt"></i>&nbsp;
                                            Eliminar</button>
                                    </div>

                                    <div class="col-md-4">
                                        <ul>
                                            <li>Formato : JPG</li>
                                            <li>Peso máximo : 2Mb</li>
                                            <li>Ancho recomendado : 600px</li>
                                            <li>Largo recomendado : 400px</li>
                                        </ul>
                                    </div>

                                </div>

                            </div>

                            <div [hidden]="false" class="ibox-body">
                                <form>
                                    <div class="form-row col-md-12">
                                        <div
                                            style="width: 420px !important; height: 420px !important; margin-top: 2rem;">
                                            <img class="card-img-top img-fluid" width="156px" height="3737"
                                                [src]="imagenCabecera" (error)="sinImagenCabecera()">
                                        </div>
                                    </div>
                                </form>
                            </div>

                        </ng-template>
                    </li>
                </ul>
                <div [ngbNavOutlet]="nav"></div>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer">
    <div>
        <button type="button" class="btn btn-rounded btn-info m-b-15 mb-0" tabindex="11" (click)="guardarModificar()"><i
                class="fa fa-save"></i> Guardar</button>
        <button type="button" class="btn btn-rounded btn-warning m-b-15 mb-0" tabindex="12" (click)="cancelarPanel()"><i
                class="fa fa-times-circle"></i> Cancelar</button>
    </div>
</div>